import base from "./base.service"
const addMissingPerson = payload => base.post('emergencies/add', payload)
const emergencyList = payload => base.get(`emergencies/list?type=${payload?.type}&limit=${payload?.limit}`)

const emergencyListDetails = id => base.get(`emergencies/emergency/${id}`)
const denyPayment =id=>base.get(`emergencies/denyPayment/${id}`)
export const emergencyService = {
    addMissingPerson,
    emergencyList,
  emergencyListDetails,
  denyPayment
}